import { render, staticRenderFns } from "./ModalUploadBanner.vue?vue&type=template&id=33642f1f&scoped=true"
import script from "./ModalUploadBanner.vue?vue&type=script&lang=js"
export * from "./ModalUploadBanner.vue?vue&type=script&lang=js"
import style0 from "./ModalUploadBanner.vue?vue&type=style&index=0&id=33642f1f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33642f1f",
  null
  
)

export default component.exports